import React from 'react';

const SectionTitle = ({ title, required = true }) =>
  title && (
    <h3 className={'text--subheader'}>
      {title}
      {required && <sup>*</sup>}
    </h3>
  );

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/components/SectionTitle.js